import ChevronDownIcon from "@redotech/redo-icons/chevron-down.svg";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { SettingCard } from "../../returns-package-protection/v2/component/setting-card";
import * as styles from "./step-card.module.css";

export const StepCard = memo(function StepCard({
  title,
  description,
  IconComponent,
  open,
  onToggle,
  headerRight,
  fullWidthBody,
  children,
}: {
  title: string;
  description: string;
  IconComponent: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  open: boolean;
  onToggle: () => void;
  headerRight?: React.ReactNode;
  fullWidthBody?: boolean;
  children: React.ReactNode;
}) {
  return (
    <SettingCard>
      <div className={styles.header} onClick={onToggle}>
        <Flex align="center" gap="lg" p="xl">
          <span className={styles.icon}>
            <IconComponent />
          </span>
          <Flex dir="column" gap="xxs" grow="1">
            <Text fontSize="sm" fontWeight="semibold">
              {title}
            </Text>
            <Text fontSize="xs" textColor="tertiary">
              {description}
            </Text>
          </Flex>
          {headerRight && (
            <div onClick={(e: React.MouseEvent) => e.stopPropagation()}>
              {headerRight}
            </div>
          )}
          <ChevronDownIcon
            className={`${styles.chevron} ${open ? styles.chevronOpen : ""}`}
          />
        </Flex>
      </div>
      {open && (
        <div className={fullWidthBody ? styles.body : styles.bodyPadded}>
          {children}
        </div>
      )}
    </SettingCard>
  );
});
